import Vue from 'vue'
Vue.filter("formatDate", formatDate);
Vue.prototype.formatDate = formatDate;
function formatDate(value) {
  if(value == null || value == "" ){
    return "--";
  }
  var date = new Date(parseInt(value));
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
}
Vue.filter("formatDateTime", formatDateTime);
Vue.prototype.formatDateTime = formatDateTime;
function formatDateTime(value) {
  if(value == null || value == "" ){
    return "";
  }
  var date = new Date(parseInt(value));
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if(hours<10){
    hours = "0" + hours;
  }
  if(minutes<10){
    minutes = "0" + minutes;
  }
  return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
}

Vue.filter("formatDateToMonthDay", formatDateToMonthDay);
Vue.prototype.formatDateToMonthDay = formatDateToMonthDay;
function formatDateToMonthDay(value) {
  if(value == null || value == "" ){
    return "--";
  }
  var date = new Date(parseInt(value));
  var day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  var month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return  month + "-" + day ;
}
Vue.filter("formatDateToDay", formatDateToDay);
Vue.prototype.formatDateToDay = formatDateToDay;
function formatDateToDay(value) {
  if(value == null || value == "" ){
    return "--";
  }
  var date = new Date(parseInt(value));
  var day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return  day;
}
Vue.filter("formatCheckCycle", formatCheckCycle);
Vue.prototype.formatCheckCycle = formatCheckCycle;
 function formatCheckCycle(value) {
  if(value == null || value == "" ){
    return "";
  }
  var checkCycleMsg = "";
  if (value == "0") {
    checkCycleMsg = "一周";
  }else if(value == "1") {
    checkCycleMsg = "一个月";
  }else if(value == "2") {
    checkCycleMsg = "三个月";
  }else if(value == "3") {
    checkCycleMsg = "半年";
  }else if(value == "4") {
    checkCycleMsg = "一年";
  }else if(value == "9") {
    checkCycleMsg = "长期有效";
  }
  return checkCycleMsg;
}

Vue.filter("formatBillType", formatBillType);
Vue.prototype.formatBillType = formatBillType;
function formatBillType(value) {
  if(value == null || value == "" ){
    return "";
  }
  var billType = "";
  if (value == 1) {
    billType = "消费-新购";
  }else if(value == "2") {
    billType = "消费-变更";
  } else if(value == "3") {
    billType = "消费-续订";
  }else if(value == "4") {
    billType = "消费-使用";
  }else if(value == "5") {
    billType = "消费-按需计费";
  }
  return billType;
}

Vue.filter("formatOrderType", formatOrderType);

Vue.prototype.formatOrderType = formatOrderType;
function formatOrderType(value) {
  if(value == null || value == "" ){
    return "";
  }
  var orderType = "";
  if (value == "1") {
    orderType = "云授权";
  }else if(value == "2") {
    orderType = "SDK授权";
  }else if(value == "3") {
    orderType = "托管应用";
  }else if(value == "4") {
    orderType = "官方订单";
  }else if(value == "5") {
    orderType = "定制Logo";
  }else if(value == "6") {
    orderType = "代理转发服务";
  } else if(value == "7") {
    orderType = "时效金到期";
  } else if(value == "8") {
    orderType = "增值服务扣费";
  }
  return orderType;
}

Vue.filter("formatOrderStatus", formatOrderStatus);
Vue.prototype.formatOrderStatus = formatOrderStatus;
function formatOrderStatus(value) {
  if(value == null || value == "" ){
    return "";
  }
  var orderStatus = "";
  if (value == "Y") {
    orderStatus = "已确认";
  }else if(value == "N") {
    orderStatus = "已完结";
  }
  return orderStatus;
}


Vue.filter("formatChargeType", formatChargeType);
Vue.prototype.formatChargeType = formatChargeType;
function formatChargeType(value) {
  if(value == null || value == "" ){
    return "";
  }
  var orderType = "";
  if (value == "1") {
    orderType = "包年/包月";
  }else if(value == "2") {
    orderType = "按需";
  }
  return orderType;
}
Vue.filter("changeMinutesToHours", changeMinutesToHours);
Vue.prototype.changeMinutesToHours = changeMinutesToHours;
function changeMinutesToHours(value) {
  if(value){
    return parseInt(value/60)
  }else return 0;
}

//秒数转换成n天n小时n分n秒
Vue.filter("secondsToDate", function secondsToDate(seconds) {
  if (seconds) {
    var milliseconds = parseInt(seconds) * 1000;  //两个时间戳相差的毫秒数
    var days = Math.floor(milliseconds / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = milliseconds % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000);        //计算分钟数后剩余的毫秒数
    var seconds = Math.floor(leave3 / 1000);
    var time = "";
    if(days != 0){
      time = days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
    }else if(hours != 0){
      time = hours + "时" + minutes + "分" + seconds + "秒";
    }else if(minutes != 0){
      time =  minutes + "分" + seconds + "秒";
    }else if(seconds != 0){
      time = seconds + "秒";
    }
    return time;
  } else {
    return "0秒"
  }
})


//分钟数转换成n天n小时n分
Vue.filter("minutesToDate", function secondsToDate(time) {
  if (time) {
    var milliseconds = parseInt(time) * 1000 * 60;  //两个时间戳相差的毫秒数
    var days = Math.floor(milliseconds / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = milliseconds % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    days = days == 0 ? "" : days +"天";
    hours = hours == 0 ? "" : hours +"时";
    minutes = minutes == 0 ? "" : minutes +"分";
    return days + hours  + minutes;
  } else {
    return "0"
  }
})

/*从Byte转换成kb，Mb等*/
Vue.filter("transformSendRate", function transformSendRate(size) {
  if (!size) {
    return '0';
  }
  var num = 1024.0; // byte
  size *= 8;
  if (size < num) {
    return size + 'b';
  }
  if (size < Math.pow(num, 2)) {
    return (size / num).toFixed(2) + 'Kb';
  } // kb
  if (size < Math.pow(num, 3)) {
    return (size / Math.pow(num, 2)).toFixed(2) + 'Mb';
  } // M
  if (size < Math.pow(num, 4)) {
    return (size / Math.pow(num, 3)).toFixed(2) + 'Gb';
  } // G
  return (size / Math.pow(num, 4)).toFixed(2) + 'Tb'; // T
});

/*从Byte转换成kB，MB等*/
Vue.filter("transformByte", function transformByte(size) {
  if (!size || size < 0) {
    return '0';
  }

  var num = 1024.0; // byte

  if (size < num) {
    return size + 'B';
  }
  if (size < Math.pow(num, 2)) {
    return (size / num).toFixed(2) + 'K';
  } // kb
  if (size < Math.pow(num, 3)) {
    return (size / Math.pow(num, 2)).toFixed(2) + 'M';
  } // M
  if (size < Math.pow(num, 4)) {
    return (size / Math.pow(num, 3)).toFixed(2) + 'G';
  } // G
  return (size / Math.pow(num, 4)).toFixed(2) + 'T'; // T
});
Vue.filter("fileStatus", function fileStatus(status) {
  const fileStatusStr = {
    wait: '待上传',
    uploading: '上传中',
    success: '成功',
    error: '失败',
    secondPass: '已秒传',
    pause: '暂停',
    resume: '恢复'
  };
  return fileStatusStr[fileStatus[status]];
});
Vue.filter("formatSdkType", formatSdkType);
Vue.prototype.formatSdkType = formatSdkType;
function formatSdkType(value) {
  if(value == null || value == "" ){
    return "";
  }
  var sdkType = "";
  sdkType = value.replace("1"," 安卓 ").replace("2"," VR ").replace("3"," Web ");
  return sdkType;
}
